module.exports = __webpack_public_path__ + "static/media/StarFill.03c2c864.svg";